import { Coordinates } from '../types';

export const separateLongLat = (searchString: string) => {
  const commaPos = searchString.indexOf(',');
  const lon = parseFloat(searchString.substring(0, commaPos));
  const lat = parseFloat(
    searchString.substring(commaPos + 1, searchString.length),
  );
  return { lon, lat };
};

export const splitCoord = (text: string) => {
  const [initLon, initLat] = text.split(',');
  const lon = parseFloat(initLon);
  const lat = parseFloat(initLat);
  return { lon, lat };
};

export const isLatitude = (num: number) => {
  return typeof num === 'number' && isFinite(num) && Math.abs(num) <= 90;
};

export const isLongitude = (num: number) => {
  return typeof num === 'number' && isFinite(num) && Math.abs(num) <= 180;
};

const CLOSE_TO_ZERO_THRESHOLD = 0.0001;

/**
 * Validates if the given coordinates are valid:
 * - Not null or undefined
 * - Latitude within -90 to 90 degrees
 * - Longitude within -180 to 180 degrees
 * - Not "practically zero" (both lon and lat within the threshold)
 * @param coords The coordinates to validate
 * @returns True if the coordinates are valid, false otherwise
 */
export const areCoordinatesValid = (coords: Coordinates | null): boolean => {
  if (coords == null || coords.lon == null || coords.lat == null) {
    return false;
  }

  if (
    Math.abs(coords.lon) <= CLOSE_TO_ZERO_THRESHOLD ||
    Math.abs(coords.lat) <= CLOSE_TO_ZERO_THRESHOLD
  ) {
    return false;
  }

  return isLatitude(coords.lat) && isLongitude(coords.lon);
};
